import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyPipe } from '@angular/common';

import { DirectiveModule } from '../directives/directive.module';

import { PlanRoutingModule } from './plan-routing.module';
import { PlanComponent } from './plan.component';

import { ComponentContainerComponent } from '../component-container/component-container.component';
import { SavePlanModule } from '../context-components/save-plan/save-plan.module';

import { HighchartsChartModule } from 'highcharts-angular';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ResultComponent } from './result/result.component';
import { CreatePlanComponent } from './../create-plan/create-plan.component';
import { ClientProfileComponent } from './../create-plan/client-profile/client-profile.component';
import { ClientListComponent } from './client-list/client-list.component';
import { CashFlowComponent } from './cash-flow/cash-flow.component';
import { CashFlowTableComponent } from './cash-flow-table/cash-flow-table.component';
import { AssetProjectionComponent } from './asset-projection/asset-projection.component';
import { AccountListComponent } from './account-list/account-list.component';
import { LliabilityListComponent } from './liability-list/liability-list.component';
import { GoalDetailsComponent } from './goal-details/goal-details.component';
import { GoalsComponent } from './goals/goals.component';
import { GoalExpenseComponent } from './goal-expense/goal-expense.component';
import { ExpenseListComponent } from './expense-list/expense-list.component';
import { IncomeListComponent } from './income-list/income-list.component';
import { EditExpenseComponent } from './edit-expense/edit-expense.component';
import { EditIncomeComponent } from './edit-income/edit-income.component';
import { SettingsComponent } from '../settings/settings.component';
import { MilestoneComponent } from './milestone/milestone.component'; 
import { IncomeComponent } from './income/income.component';
import { FamilyViewComponent } from './family-view/family-view.component';
import { IncomeSummaryComponent } from './income-summary/income-summary.component';
import { ExpenseSummaryComponent } from './expense-summary/expense-summary.component';
import { AccountSummaryComponent } from './account-summary/account-summary.component';
import { ClientSummaryComponent } from './client-summary/client-summary.component';
import { EditSavingComponent } from './edit-savings/edit-saving.component';
import { GPSnackBarComponent } from '../common/gp-snack-bar/gp-snack-bar.component';
import { TaxPortfolioComponent } from './tax-portfolio/tax-portfolio.component';
import { PVFVSettingComponent } from '../settings/pvfv-setting/pvfv-setting.component';
import { EditClientComponent } from './edit-client/edit-client.component';
import { NetCashFlowByYearComponent } from './net-cash-flow-by-year/net-cash-flow-by-year.component';
import { ChartLoadingAnimationComponent } from '../common/chart-loading-animation/chart-loading-animation.component';
import { ClientSearchComponent } from '../common/client-search/client-search';


@NgModule({
  declarations: [ResultComponent, 
    ComponentContainerComponent, 
    PlanComponent, 
    CreatePlanComponent, 
    ClientProfileComponent, 
    ClientListComponent, 
    CashFlowComponent,
    CashFlowTableComponent, 
    AccountListComponent, 
    LliabilityListComponent,
    GoalsComponent,
    GoalDetailsComponent,
    GoalExpenseComponent,
    ExpenseListComponent, 
    EditExpenseComponent, 
    EditIncomeComponent, 
    IncomeListComponent, 
    AssetProjectionComponent,
    SettingsComponent,
    MilestoneComponent,
    IncomeComponent,
    FamilyViewComponent,
    ExpenseSummaryComponent,
    IncomeSummaryComponent,    
    AccountSummaryComponent,
    ClientSummaryComponent,
    EditSavingComponent,
    GPSnackBarComponent,
    TaxPortfolioComponent,
    PVFVSettingComponent,
    EditClientComponent,
    NetCashFlowByYearComponent,
    ChartLoadingAnimationComponent,
    ClientSearchComponent],
  imports: [
    CommonModule,
    PlanRoutingModule,
    SavePlanModule,
    HighchartsChartModule,
    FormsModule,
    DragDropModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatRippleModule,
    MatExpansionModule,
    MatMenuModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    MatTableModule,
    MatSnackBarModule,
    MatBadgeModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,    
    DirectiveModule       
  ],
  // entryComponents: [
  //   GPSnackBarComponent
  // ],
  providers: [CurrencyPipe]
})
export class PlanModule { }
